import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29080aac"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Feedback Form")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Request a feature, report a bug, or chat with us about anything Monarch-related. ", -1))
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { class: "fields" }
const _hoisted_5 = { class: "feedback" }
const _hoisted_6 = { class: "details" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Submitting this form starts a ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "public", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" discussion on our ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("help desk")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" on GitHub with ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "all of the information above", -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode(". You'll get a link to the discussion once it's created. ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Submitting feedback")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Error submitting feedback")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("View your submitted feedback here.")

import { computed } from "vue";
import { useRoute } from "vue-router";
import { useLocalStorage } from "@vueuse/core";
import { truncate } from "lodash";
import parser from "ua-parser-js";
import AppTextbox from "@/components/AppTextbox.vue";
import { collapse } from "@/util/string";
import { postFeedback } from "@/api/feedback";
import { useQuery } from "@/util/composables";

/** route info */
interface Props {
  /** whether form is inside a modal */
  modal?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TheFeedbackForm',
  props: {
    modal: { type: Boolean, default: false }
  },
  setup(__props: any) {

const route = useRoute();



/** user's name */
const name = useLocalStorage("feedback-form-name", "");
/** user's email */
const email = useLocalStorage("feedback-form-email", "");
/** user's github name */
const github = useLocalStorage("feedback-form-github", "");
/** user's freeform feedback */
const feedback = useLocalStorage("feedback-form-feedback", "");

/** list of automatic details to record */
const details = computed(() => {
  /** get browser/device/os/etc details from ua parser library */
  const { browser, device, os, engine, cpu } = parser();

  /** filter and join strings together */
  const concat = (...array: Array<string | undefined>) =>
    array.filter((e) => e && e !== "()").join(" ");

  /** make map of desired properties in desired stringified format */
  return {
    Page: route.fullPath,
    Browser: concat(browser.name, browser.version),
    Device: concat(device.vendor, device.model, device.type),
    OS: concat(os.name, os.version, cpu.architecture),
    Engine: concat(engine.name, engine.version),
  };
});

/** when form submitted */
async function onSubmit() {
  /**
   * only proceed if submitted through button, not "implicitly" (enter press).
   * https://stackoverflow.com/questions/895171/prevent-users-from-submitting-a-form-by-hitting-enter
   */
  if ((document.activeElement as Element).matches("button[type='submit']"))
    await submitFeedback();
}

/** post feedback to backend */
const {
  query: submitFeedback,
  data: link,
  isLoading,
  isError,
  isSuccess,
} = useQuery(async function () {
  /** make issue title (unclear what char limit is?) */
  const title = [
    "Feedback form",
    truncate(name.value, { length: 20 }),
    truncate(collapse(feedback.value), { length: 60 }),
  ].join(" - ");

  /** make issue body markdown */
  const body = [
    "**Name**",
    name.value,
    "",
    "**Email**",
    email.value,
    "",
    "**GitHub Username**",
    github.value,

    "",
    "**Details**",
    ...Object.entries(details.value).map(([key, value]) => `${key}: ${value}`),
    "",
    "",
    feedback.value,
  ].join("\n");

  /** post feedback and get link of created issue */
  const link = await postFeedback(title, body);

  resetForm();

  return link;
}, "");

/** clear form data from storage after successful submit */
function resetForm() {
  name.value = null;
  email.value = null;
  github.value = null;
  feedback.value = null;
}

return (_ctx: any,_cache: any) => {
  const _component_AppHeading = _resolveComponent("AppHeading")!
  const _component_AppLink = _resolveComponent("AppLink")!
  const _component_AppStatus = _resolveComponent("AppStatus")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.modal)
      ? (_openBlock(), _createBlock(_component_AppHeading, {
          key: 0,
          level: 1
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _hoisted_2,
    _createElementVNode("form", {
      class: "form",
      onSubmit: _withModifiers(onSubmit, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(AppTextbox, {
          modelValue: _unref(name),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? (name).value = $event : null)),
          modelModifiers: { trim: true },
          title: "Name",
          description: "So we can address you",
          placeholder: "Jane Smith"
        }, null, 8, ["modelValue"]),
        _createVNode(AppTextbox, {
          modelValue: _unref(email),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(email) ? (email).value = $event : null)),
          modelModifiers: { trim: true },
          title: "Email",
          description: "So we can follow up with you",
          placeholder: "jane.smith@gmail.com",
          type: "email"
        }, null, 8, ["modelValue"]),
        _createVNode(AppTextbox, {
          modelValue: _unref(github),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(github) ? (github).value = $event : null)),
          modelModifiers: { trim: true },
          title: "GitHub username",
          description: "So we can tag you",
          placeholder: "@janesmith"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(AppTextbox, {
            modelValue: _unref(feedback),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(feedback) ? (feedback).value = $event : null)),
            title: "Feedback",
            description: "Please give us as many details as possible!",
            placeholder: "",
            required: true,
            multi: true
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(details), (value, key) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
            _createElementVNode("span", null, _toDisplayString(key), 1),
            _createElementVNode("span", {
              innerHTML: value.replaceAll(/([^A-Za-z0-9])/g, '<wbr />$1')
            }, null, 8, _hoisted_7)
          ], 64))
        }), 128))
      ]),
      _createElementVNode("p", null, [
        _hoisted_8,
        _hoisted_9,
        _hoisted_10,
        _createVNode(_component_AppLink, { to: "https://github.com/monarch-initiative/helpdesk" }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }),
        _hoisted_12,
        _hoisted_13,
        _hoisted_14
      ]),
      (_unref(isLoading))
        ? (_openBlock(), _createBlock(_component_AppStatus, {
            key: 0,
            code: "loading"
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(isError))
        ? (_openBlock(), _createBlock(_component_AppStatus, {
            key: 1,
            code: "error"
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(isSuccess))
        ? (_openBlock(), _createBlock(_component_AppStatus, {
            key: 2,
            code: "success"
          }, {
            default: _withCtx(() => [
              (_unref(link))
                ? (_openBlock(), _createBlock(_component_AppLink, {
                    key: 0,
                    to: _unref(link)
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_AppButton, {
            key: 3,
            text: "Submit",
            icon: "paper-plane",
            type: "submit"
          }))
    ], 40, _hoisted_3)
  ], 64))
}
}

})